import React from 'react';
import { Modal, Button, theme } from 'antd';
import { useTranslation } from 'react-i18next';

interface UnsavedChangesModalProps {
    open: boolean;
    onStay: () => void;
    onLeave: () => void;
    message?: string;
}

const clamp = (min: number, val: number, max: number) => {
    return Math.min(Math.max(val, min), max);
};

export const UnsavedChangesModal: React.FC<UnsavedChangesModalProps> = ({
    open,
    onStay,
    onLeave,
    message
}) => {
    const { t } = useTranslation();
    const { token } = theme.useToken();

    return (
        <Modal
            open={open}
            onCancel={onStay}
            footer={null}
            closable={false}
            width={clamp(90, 420, 520)}
            style={{ backdropFilter: 'blur(4px)' }}
            bodyStyle={{ padding: '40px 32px', backgroundColor: token.colorBgContainer }}
        >
            <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 20 }}>
                <div
                    style={{
                        width: 72,
                        height: 72,
                        borderRadius: '50%',
                        background: 'var(--app-warning-soft-bg)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: 32,
                        border: '2px solid var(--app-warning-soft-border)'
                    }}
                >
                    <span role="img" aria-label="warning" style={{ color: 'var(--app-warning-soft-text)' }}>⚠️</span>
                </div>
                <div>
                    <h2 style={{ margin: '0 0 8px 0', fontSize: 20, fontWeight: 700, color: 'var(--app-warning-soft-text)', letterSpacing: '-0.3px' }}>
                        {t('common.unsavedChanges', { defaultValue: 'Unsaved Changes' })}
                    </h2>
                    <p style={{ margin: 0, fontSize: 14, color: token.colorTextSecondary, fontWeight: 400, lineHeight: 1.5 }}>
                        {message || t('common.unsavedChangesMessage', { defaultValue: 'You have unsaved changes. Are you sure you want to leave without saving?' })}
                    </p>
                </div>
                <div style={{ display: 'flex', gap: 16, justifyContent: 'center' }}>
                    <Button
                        onClick={onStay}
                        style={{ borderRadius: 10, padding: '10px 32px', fontSize: 14, fontWeight: 600, height: 40, minWidth: 120 }}
                    >
                        {t('common.stay', { defaultValue: 'Stay' })}
                    </Button>
                    <Button
                        type="primary"
                        danger
                        onClick={onLeave}
                        style={{ borderRadius: 10, padding: '10px 32px', fontSize: 14, fontWeight: 600, height: 40, minWidth: 120 }}
                    >
                        {t('common.leave', { defaultValue: 'Leave' })}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};
